import I18n from 'I18n';
import { useHistory } from 'react-router-dom';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { DO_NOT_DISPLAY_THREAD } from 'copilot-toolkit/constants/PromptThread';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addPromptMessageToThread } from '../chat/slices/chat';
import { chatV2Actions } from '../chat/slices/chatv2';
import { updateActiveActionToPrompt } from '../chat/slices/promptUser';
import { useHostAppContext } from '../hostAppContext/hooks/useAppContext';
import { useAssistantSwitcher } from './useAssistantSwitcher';
import { Paths } from '../components/Routes';
const useGetI18nTextOnceAppIsReady = () => {
  const {
    isAppSetupComplete
  } = useHostAppContext();
  const [key, setKey] = useState('');
  const [params, setParams] = useState(undefined);
  const [resolveMethod, setResolveMethod] = useState(null);
  useEffect(() => {
    if (isAppSetupComplete && resolveMethod) {
      resolveMethod(I18n.text(key, params));
      setResolveMethod(null);
      setKey('');
      setParams(undefined);
    }
  }, [isAppSetupComplete, resolveMethod, key, params]);
  const getI18nText = useCallback((queryKey, queryParams = {}) => {
    return new Promise((resolve, reject) => {
      if (isAppSetupComplete) {
        resolve(I18n.text(queryKey, queryParams));
      } else {
        const returnEmptyStringTimeout = setTimeout(() => {
          reject(new Error('useGetI18nTextOnceAppIsReady: Failed to resolve I18n text after 5 seconds'));
        }, 5000);
        setKey(queryKey);
        setParams(queryParams);
        setResolveMethod(() => resolve);
        clearTimeout(returnEmptyStringTimeout);
      }
    });
  }, [isAppSetupComplete]);
  return getI18nText;
};
export const useUpdateActiveActionToPrompt = () => {
  const dispatch = useDispatch();
  const getI18nTextOnceAppIsReady = useGetI18nTextOnceAppIsReady();
  const {
    updateAssistantType
  } = useAssistantSwitcher();
  const history = useHistory();
  return action => {
    var _action$messageMetaIn;
    dispatch(updateActiveActionToPrompt(action));
    const {
      promptThread
    } = action.promptData;
    history.push(Paths.CHAT);
    if (action !== null && action !== void 0 && (_action$messageMetaIn = action.messageMetaInfo) !== null && _action$messageMetaIn !== void 0 && _action$messageMetaIn.copilotAssistantMode) {
      var _action$messageMetaIn2;
      updateAssistantType(action === null || action === void 0 || (_action$messageMetaIn2 = action.messageMetaInfo) === null || _action$messageMetaIn2 === void 0 ? void 0 : _action$messageMetaIn2.copilotAssistantMode);
    }
    if (promptThread === DO_NOT_DISPLAY_THREAD) {
      return;
    } else if (promptThread) {
      dispatch(chatV2Actions.addPromptMessageToThread(promptThread));
      dispatch(addPromptMessageToThread(promptThread));
    } else {
      getI18nTextOnceAppIsReady('promptUserInput.threadPromptText').then(fallbackThreadMessage => {
        dispatch(chatV2Actions.addPromptMessageToThread(fallbackThreadMessage));
        dispatch(addPromptMessageToThread(fallbackThreadMessage));
      }).catch(e => {
        consoleIfNotProd.error(e);
        dispatch(chatV2Actions.addPromptMessageToThread(''));
        dispatch(addPromptMessageToThread(''));
      });
    }
  };
};